import moment from "moment";

export const formattedDate = (date: string | Date) => {
  return (
    <pre>
      {`${moment(date).format("DD/MM/YYYY")}`}
      {"\n"}
      {`${moment(date).format("HH:mm")}`}
    </pre>
  );
};

export const getDifferenceInDays = (
  fromDate: string | Date,
  toDate: string | Date,
  withWord: boolean | undefined = true
) => {
  const startDate = moment(fromDate);
  const endDate = moment(toDate);

  const daysDifference = endDate.diff(startDate, "days");
  const daysDifferenceWord = withWord
    ? daysDifference === 1
      ? "day"
      : "days"
    : "";

  return daysDifference > 0 ? `${daysDifference} ${daysDifferenceWord}` : "-";
};

export const dateDifferenceCheck = (
  id: string | undefined,
  date: Date | string,
  compareDate: Date | string,
  range: string
) => {
  return ((id && !moment(date).isSame(moment(compareDate), "day")) ?? !id)
    ? { [range]: moment(compareDate).format("YYYY-MM-DD") }
    : null;
};

export const isWithinRange = (
  fromDate: Date | string,
  toDate: Date | string
) => {
  const currentDate = moment();
  const from = moment(fromDate);
  const to = moment(toDate);

  return currentDate.isBetween(from, to, undefined, "[]");
};
